import { modifyNodeId } from '../assets/js/common'

function loadJs(url = '') {
  if (!url) return
  if (!loadJs.cache) loadJs.cache = {}
  if (loadJs.cache[url]) return Promise.resolve()
  return new Promise((resolve, reject) => {
    // 1 动态引用js；2 直接动态追加代码
    let compLoadType = 2;
    if (location.search.indexOf('compLoadType=1') >= 0) {
      compLoadType = 1
    }

    // 先看看组件脚本mapping里有没有
    const content = window.pageInfo && window.pageInfo.compContentMapping && window.pageInfo.compContentMapping[url];
    // console.log('loadJs', url, content)
    if (compLoadType === 2 && content && content.length > 0) {
      _loadcontent(url, content)
      resolve()
      return
    }

    _loadjs(
      url,
      () => {
        loadJs.cache[url] = 'cached'
        resolve()
      },
      () => {
        console.error(`${url} 加载失败`)
        reject(new Error(`${url} 加载失败`))
      }
    )
  })

  function _loadjs(url, fn, fail) {
    var script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = fn;
    script.onerror = fail;
    (document.body || document.head).appendChild(script)
  }

  function _loadcontent(url, content, fn, fail) {
    var script = document.createElement('script');
    script.type = 'text/javascript'
    script.setAttribute('data-url', url);
    script.innerHTML = content;
    script.onload = fn;
    script.onerror = fail;
    (document.body || document.head).appendChild(script)
  }
}

export default {
  loadJs
}

export {
  loadJs
}
